<div #text id="text" class="text" data-title="Contact">
  Pour toute location ou demande d'informations, vous pouvez nous contacter...
  <br />
  <br />
  Par mail&nbsp;:
  <br />
  <a href="mailto:audio@technomad.fr">audio&#64;technomad.fr</a>
  <br />
  <br />
  Par téléphone&nbsp;:
  <br />
  <a href="tel:0632526275">06 32 52 62 75</a>
  <br />
  <br />
  Vous pouvez également nous retrouver sur les réseaux&nbsp;:
  <br />
  <div class="social-icons">
    <a
      href="http://bit.ly/TA_fcbk"
      target="_blank"
      rel="noreferrer noopener"
      title="Technomad Audio sur Facebook"
    >
      <fa-stack size="2x">
        <fa-icon [icon]="['fas', 'square']" stackItemSize="2x"></fa-icon>
        <fa-icon
          [icon]="['fab', 'facebook-f']"
          [inverse]="true"
          stackItemSize="1x"
        ></fa-icon>
      </fa-stack>
    </a>
    <a
      href="http://bit.ly/TA_insta"
      target="_blank"
      rel="noreferrer noopener"
      title="Technomad Audio sur Instagram"
    >
      <fa-stack size="2x">

        <fa-icon [icon]="['fas', 'square']" stackItemSize="2x"></fa-icon>
        <fa-icon
          [icon]="['fab', 'instagram']"
          [inverse]="true"
          stackItemSize="1x"
        ></fa-icon>
      </fa-stack>
    </a>
    <a
      href="https://bit.ly/TA_ggl"
      target="_blank"
      rel="noreferrer noopener"
      title="Technomad Audio sur Google"
    >
      <fa-stack size="2x">
        <fa-icon [icon]="['fas', 'square']" stackItemSize="2x"></fa-icon>
        <fa-icon
          [icon]="['fab', 'google']"
          [inverse]="true"
          stackItemSize="1x"
        ></fa-icon>
      </fa-stack>
    </a>
    <!-- <a
      href="https://bit.ly/TA_pntrst"
      target="_blank"
      rel="noreferrer noopener"
      title="Technomad Audio sur Pinterest"
    >
      <fa-stack>
        <fa-icon [icon]="['fas', 'square']" stackItemSize="2x"></fa-icon>
        <fa-icon
          [icon]="['fab', 'pinterest-p']"
          [inverse]="true"
          stackItemSize="1x"
        ></fa-icon>
      </fa-stack>
    </a> -->
  </div>
</div>

<div #map id="map" class="map" data-title="Carte">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d688535.7642571396!2d-2.0347986953595174!3d47.61460645109645!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x480878e9fc6582d3%3A0x7c1233ad87d98622!2sTechnomad%20Audio!5e0!3m2!1sfr!2sfr!4v1695590043874!5m2!1sfr!2sfr"
    width="100%"
    height="100%"
    frameborder="0"
    scrolling="no"
    marginheight="0"
    marginwidth="0"
    style="border: 0;"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>
</div>

<audio-anchor-scroll #anchorScroll id="anchorScroll" selector=".map, .text"></audio-anchor-scroll>